var modules_be025dea = {"container":"_bccnwu","icon":"_1nhws3c","is-arrow-turned":"_1md9auj"};
import "../../../assets/DAKU1njJ.css";

export { modules_be025dea as default };
//# sourceMappingURL=Select.module.less.js.map
